export type ExperimentDefinition = Record<string, unknown>;

export type AvailableExperiment =
  (typeof experimentsDefinitions)[keyof typeof experimentsDefinitions];

export const experimentsDefinitions: ExperimentDefinition = {};

export interface MatomoClient {
  track: () => void;
  AbTesting: {
    Experiment: { new (definition: unknown): Experiment };
  };
}

export interface Experiment {
  name: string;
  getActivatedVariationName: () => string;
  variations: Variation[];
  selectRandomVariation: () => string;
}

export interface Variation {
  name: string;
  activate: () => unknown;
}
